import {
    addImageNonStretch,
    darkTitle,
    darkSubtitle,
    blackParagraph,
    whiteSideSubtitle,
    whiteSidePageNumber,
    greenSubtitle,
    blackListitem,
    cut_off,
    allocation,
    darkParagraph
} from "./ExportProductPPT";

import background_1 from "../../assets/product_ppt/background_3_building.png";
import background_2 from "../../assets/product_ppt/background_2.png";
import foot_1 from "../../assets/product_ppt/foot_1.png";
import leaf_1 from "../../assets/product_ppt/leaf_1.png";

export const buildingSideSubtitleContent = "B U I L D I N G  L C A  R E P O R T  2 0 2 5";

export const addBuildingCoverPage = (pptx, data) => {
    let slide = pptx.addSlide();
    slide.background = { path: background_1 };
    slide.addText("Building Life Cycle", { x: 0.3, y: 1.97, w: 5, h: 0.79, ...darkTitle });
    slide.addText("Assessment", { x: 0.3, y: 2.71, w: 5, h: 0.79, ...darkTitle });
    slide.addText("Generated using Arivu.2025", { x: 0.3, y: 4.33, w: 3.05, h: 0.425, ...blackParagraph });
    slide.addText(data?.company?.name || "Company Inc.", { x: 3.8, y: 4.33, w: 2.5, h: 0.52, ...darkSubtitle });
    slide.addText(`${data?.company?.address || "Address"} \n${data?.company?.phone || "Phone"} \n${data?.company?.website || "Website"}`, {
        x: 3.8,
        y: 4.65,
        w: 2.7,
        h: 0.71,
        ...darkParagraph,
    });
};

// ... (keep other functions as is until addDetailedBreakdown)

export const addDetailedBreakdown = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    let num = pageNum;
    slide.addText(buildingSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("Detailed Breakdown", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle });

    if (data.sectionsChart) {
        // Chart on the left
        await addImageNonStretch(slide, data.sectionsChart, 5.0, 4.5, 3.0, 3.0);
    }
    if (data.sectionsTable) {
        // Table on the right
        await addImageNonStretch(slide, data.sectionsTable, 4.5, 4.5, 7.5, 3.0);
    }

    num++;
    return num;
};

export const addDescPages = (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    let num = pageNum;
    slide.addText(buildingSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addImage({
        path: leaf_1,
        x: 5.5,
        y: 2.65,
        w: 4.44,
        h: 2.95,
    });
    slide.addImage({
        path: foot_1,
        x: 5.6,
        y: 3.2,
        w: 0.35,
        h: 0.635,
    });

    const labelStyle = { ...greenSubtitle, fontFace: "Poppins", fontSize: 14, bold: true };
    const valueStyle = { ...blackParagraph, fontFace: "Poppins", fontSize: 12 };

    slide.addText("Goal:", { x: 0.75, y: 0.4, w: 4.37, h: 0.4, ...labelStyle });
    slide.addText(data.goal, { x: 0.75, y: 0.8, w: 4, h: 1.5, ...valueStyle });

    slide.addText("Scope:", { x: 0.75, y: 2.5, w: 4.37, h: 0.4, ...labelStyle });
    slide.addText(data.scope, { x: 0.75, y: 2.9, w: 4, h: 1.2, ...valueStyle });

    slide.addText("Functional Unit:", { x: 0.75, y: 4.3, w: 4.37, h: 0.4, ...labelStyle });
    slide.addText(data.functional_unit, { x: 0.75, y: 4.7, w: 4, h: 0.6, ...valueStyle });

    slide.addText("System Boundary:", { x: 5.5, y: 0.4, w: 4.33, h: 0.4, ...labelStyle });
    slide.addText(data.system_boundary, { x: 5.5, y: 0.8, w: 4.33, h: 1.5, ...valueStyle });

    slide.addText("Building Footprint:", { x: 5.5, y: 2.5, w: 2.77, h: 0.4, ...labelStyle });
    slide.addText(`GWP = ${data.footprint} Tons CO2e`, { x: 5.5, y: 2.9, w: 3.8, h: 0.6, ...valueStyle, fontSize: 16, color: "333333" });

    slide.addShape(pptx.ShapeType.rect, {
        x: 5.2,
        y: 0.4,
        w: 0.02,
        h: 4.8,
        fill: "EAC222",
    });
    num++;
    let slide2 = pptx.addSlide();
    slide2.background = { path: background_2 };
    slide2.addText(buildingSideSubtitleContent, whiteSideSubtitle);
    slide2.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);

    slide2.addText("Assumptions", { x: 0.75, y: 0.5, w: 5.53, h: 0.35, ...labelStyle });
    slide2.addText(data.assumptions, { x: 0.75, y: 0.85, w: 5.53, h: 0.85, ...valueStyle });

    slide2.addText("Cut-off", { x: 0.75, y: 1.95, w: 5.53, h: 0.35, ...labelStyle });
    slide2.addText(cut_off, { x: 0.75, y: 2.25, w: 5.53, h: 0.85, ...valueStyle });

    slide2.addText("Allocation", { x: 0.75, y: 3.55, w: 5.53, h: 0.35, ...labelStyle });
    slide2.addText(allocation, { x: 0.75, y: 3.85, w: 5.53, h: 0.85, ...valueStyle });
    num++;
    return num;
};

export const addInsights = (pptx, data, pageNum) => {
    let num = pageNum;
    if (!data.insights) return num;

    // --- PHASE 1: PRE-PROCESSING & CLEANUP ---

    let rawContent = Array.isArray(data.insights) ? data.insights.join(" ") : String(data.insights);


    rawContent = rawContent.replace(/\.([A-Z])/g, ". $1");


    const sentences = rawContent
        .split(/\.(?:\s+)?(?=[A-Z])/)
        .map(s => s.trim())
        .filter(s => s.length > 10)
        .map(s => s.endsWith('.') ? s : s + '.');

    // --- PHASE 2: SMART CATEGORIZATION ---

    // Define categories to create "Headings" automatically based on keywords
    const categories = [
        { title: "Data Quality & Verification", keywords: ["inconsistent", "data gaps", "verification", "total GWP", "0.0", "errors"] },
        { title: "Material Hotspots", keywords: ["Aluminium", "steel", "concrete", "hotspots", "shell", "deconstruction", "refurbishment", "interiors"] },
        { title: "Operational Energy", keywords: ["Operational energy", "B6", "energy efficiency", "insulation", "renewable", "systems"] },
        { title: "Circularity & Waste", keywords: ["virgin content", "waste content", "recycling", "reuse", "circularity", "waste reduction"] },
        { title: "General Interpretation", keywords: [] } // Fallback
    ];


    let groupedData = categories.map(c => ({ title: c.title, points: [] }));

    sentences.forEach(sentence => {
        let matched = false;

        for (let i = 0; i < categories.length - 1; i++) {
            if (categories[i].keywords.some(k => sentence.toLowerCase().includes(k.toLowerCase()))) {
                groupedData[i].points.push(sentence);
                matched = true;
                break;
            }
        }

        if (!matched) {
            groupedData[categories.length - 1].points.push(sentence);
        }
    });


    const validGroups = groupedData.filter(g => g.points.length > 0);

    // --- PHASE 3: RENDERING WITH LAYOUT CHECKS ---

    let slide = pptx.addSlide();
    slide.addText(buildingSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("LCA Interpretation", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle, fontFace: "Poppins" });

    // Formatting Constants
    const startY = 1.0;
    const margin = 0.75;
    const slideHeight = 5.625;
    const headerHeight = 0.45;
    const lineSpacing = 0.35;

    let currentY = startY;

    validGroups.forEach((group) => {

        let estimatedGroupHeight = headerHeight + (group.points.length * lineSpacing) + 0.2;


        if (currentY + estimatedGroupHeight > 5.0) {
            // NEW SLIDE
            num++;
            slide = pptx.addSlide();
            slide.addText(buildingSideSubtitleContent, whiteSideSubtitle);
            slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
            slide.addText("LCA Interpretation (Cont.)", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle, fontFace: "Poppins" });
            currentY = startY;
        }

        // 3. Render Heading
        slide.addText(group.title, {
            x: margin,
            y: currentY,
            w: 8.5,
            h: 0.35,
            fontFace: "Poppins",
            fontSize: 14,
            bold: true,
            color: "5F7434", // Green theme color
        });
        currentY += 0.4;
        slide.addText(
            group.points.map(p => ({
                text: p,
                options: {
                    bullet: { type: "bullet", color: "333333" },
                    paraSpaceAfter: 6, // Space between bullets
                    fontFace: "Poppins",
                    fontSize: 11,
                    color: "333333",
                    breakLine: true
                }
            })),
            {
                x: margin,
                y: currentY,
                w: 8.5,
                h: group.points.length * lineSpacing, // Dynamic height container
                align: "left",
                valign: "top"
            }
        );


        currentY += (group.points.length * lineSpacing) + 0.3;
    });

    num++;
    return num;
};

export const addHotspots = (pptx, data, pageNum) => {
    let tableBlocks = [];
    let maxLetters = 500;
    let currentBlock = [];
    let currentCount = 0;
    let num = pageNum;
    if (!data.env_hotspot) {
        return num;
    }
    for (const item of data.env_hotspot) {
        const length = Math.max(item.category.length, item.hotspot.length, item.recommendation.length);
        if (currentCount + length > maxLetters && currentBlock.length > 0) {
            tableBlocks.push(currentBlock);
            currentBlock = [];
            currentCount = 0;
        }
        currentBlock.push(item);
        currentCount += length;
    }
    tableBlocks.push(currentBlock);

    for (const item of tableBlocks) {
        let slide = pptx.addSlide();
        slide.addText(buildingSideSubtitleContent, whiteSideSubtitle);
        slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
        slide.addText("Environmental Hotspots", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle });

        const tableData = [
            [
                { text: "Category", options: { fill: "5F7434", color: "FFFFFF", bold: true, align: "center", valign: "middle" } },
                { text: "Hotspot", options: { fill: "5F7434", color: "FFFFFF", bold: true, align: "center", valign: "middle" } },
                { text: "Recommendation", options: { fill: "5F7434", color: "FFFFFF", bold: true, align: "center", valign: "middle" } }
            ],
            ...item.map((i, idx) => [
                { text: i.category, options: { fill: idx % 2 === 0 ? "FFFFFF" : "F3F4F6", color: "374151", align: "left", valign: "middle" } },
                { text: i.hotspot, options: { fill: idx % 2 === 0 ? "FFFFFF" : "F3F4F6", color: "374151", align: "left", valign: "middle" } },
                { text: i.recommendation, options: { fill: idx % 2 === 0 ? "FFFFFF" : "F3F4F6", color: "4B5563", align: "left", valign: "middle" } }
            ])
        ];

        slide.addTable(tableData, {
            x: 0.8,
            y: 0.8,
            w: 8.7,
            colW: [2, 2.9, 3.8],
            fontSize: 11,
            fontFace: "Poppins",
            border: { pt: 0.5, color: "E5E7EB" },
            autoPage: false
        });
        num++;
    }
    return num;
};

export const addReferences = (pptx, data, pageNum) => {
    if (!data.lca_info || !data.lca_info.formattedReferences) {
        return pageNum;
    }
    const bullets = data.lca_info.formattedReferences
        .split("\n")
        .map((b) => b.trim().replace("•", ""))
        .filter(Boolean);

    let bulletBlocks = [];
    let maxLetters = 1000;
    let currentBlock = [];
    let currentCount = 0;
    let num = pageNum;
    for (const item of bullets) {
        const length = item.length;
        if (currentCount + length > maxLetters && currentBlock.length > 0) {
            bulletBlocks.push(currentBlock);
            currentBlock = [];
            currentCount = 0;
        }
        currentBlock.push(item);
        currentCount += length;
    }
    bulletBlocks.push(currentBlock);

    for (const item of bulletBlocks) {
        let slide = pptx.addSlide();
        slide.addText(buildingSideSubtitleContent, whiteSideSubtitle);
        slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
        slide.addText("References", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle, fontFace: "Poppins", fontSize: 14, bold: true });
        slide.addText(
            item.map((i) => ({ text: i, options: { bullet: true, paraSpaceAfter: 10, fontFace: "Poppins", fontSize: 12, color: "333333" } })),
            { x: 0.75, y: 0.85, w: 9, h: 4.4, align: "left", valign: "top" }
        );
        num++;
    }
    return num;
};

export const addSystemBoundary = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    let num = pageNum;
    slide.addText(buildingSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("System Boundary", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle, fontFace: "Poppins", fontSize: 14, bold: true });
    if (data.systemBoundary) {
        await addImageNonStretch(slide, data.systemBoundary, 9, 4.1, 5.1, 2.97);
    }
    num++;
    return num;
};

export const addLifeCycleStages = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    let num = pageNum;
    slide.addText(buildingSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("Life Cycle Stages Breakdown", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle, fontFace: "Poppins", fontSize: 14, bold: true });
    if (data.sankeyDiagram) {
        await addImageNonStretch(slide, data.sankeyDiagram, 9, 4.1, 5.1, 2.97);
    }
    num++;
    return num;
};

export const addCumulativeProjection = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    let num = pageNum;
    slide.addText(buildingSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("Cumulative Carbon Projection", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle, fontFace: "Poppins", fontSize: 14, bold: true });

    if (data.cumulativeProjectionChart) {
        await addImageNonStretch(slide, data.cumulativeProjectionChart, 9, 4.1, 5.1, 2.97);
    }
    num++;
    return num;
};

export const addImpactOverview = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    let num = pageNum;
    slide.addText(buildingSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("Environmental Impact Overview", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle, fontFace: "Poppins", fontSize: 14, bold: true });

    // Layout for Impact Overview charts (LCA Stages, Impact Ratio)
    if (data.lcaStagesChart) {
        // Left side
        await addImageNonStretch(slide, data.lcaStagesChart, 4.5, 4.0, 2.8, 3.0);
    }
    if (data.impactRatioChart) {
        // Right side
        await addImageNonStretch(slide, data.impactRatioChart, 4.5, 4.0, 7.4, 3.0);
    }

    num++;
    return num;
};

export const addMaterialHotspotsChart = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    let num = pageNum;
    slide.addText(buildingSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("Material Hotspots Chart", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle, fontFace: "Poppins", fontSize: 14, bold: true });

    if (data.hotspotsChart) {
        await addImageNonStretch(slide, data.hotspotsChart, 9, 4.1, 5.1, 2.97);
    }
    num++;
    return num;
};

export const addSankeyBreakdown = async (pptx, data, pageNum) => {
    let slide = pptx.addSlide();
    let num = pageNum;
    slide.addText(buildingSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("Sankey Breakdown", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle, fontFace: "Poppins", fontSize: 14, bold: true });

    if (data.sankeyChart) {
        await addImageNonStretch(slide, data.sankeyChart, 9, 4.1, 5.1, 2.97);
    }
    num++;
    return num;
};
